/**
 * @file Album Folder Purchase Header.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import Header from '../../global/Header';
import AngleLeftIcon from '../../icons/AngleLeftIcon';
import MobileHeaderSupportButton from '../../product/MobileHeaderSupportButton';
import Button from '../../global/Button';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    root: PropTypes.shape({
      id: PropTypes.string,
    }),
    album_subtype: PropTypes.string,
  }),
  openModal: PropTypes.func.isRequired,
};

const defaultProps = {
  albumFolder: {
    id: '',
    name: '',
    root: {
      id: '',
    },
  },
};

const AlbumFolderPurchaseHeader = ({ albumFolder, openModal }) => {
  const history = useHistory();

  return (
    <Header>
      <Button btnStyle="link" onClick={() => history.goBack()} className="lh-0">
        <AngleLeftIcon color="#0d84fe" height="20" />
      </Button>

      <h3 className="site-title-center">{albumFolder.name}</h3>

      <MobileHeaderSupportButton className="ml-auto" openModal={openModal} />
    </Header>
  );
};

AlbumFolderPurchaseHeader.propTypes = propTypes;
AlbumFolderPurchaseHeader.defaultProps = defaultProps;

export default AlbumFolderPurchaseHeader;
